module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Captcha

(function (fox) {
	'use strict';
	require('fox-dynamic-injection!fox-template-loader!../templates/captchaimg')(fox);

	fox.registerWidget('Captcha', {
		configure: function () {
			this.registerOptions('', {
				getCaptchaMethod: 'captcha.genId',
				template: 'captchaimg',
				captchaAlias: 'brettrossi',
				autoRender: false,
				'widgets.captchaApi': {
					widget: 'Api',
					'handleWom.captchaApiSuccessHandler': {
						widget: '@this',
						event: 'success',
						callback: '@parent:captchaApiSuccessHandler'
					}
				},
				'handleWom.putCaptcha': {
					widget: '@parent',
					event: 'addedToDom',
					callback: 'loadCaptcha'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('#captchaApi', {
				method: this.getOption('getCaptchaMethod')
			});

			this.visualParent = this.getParent();

			this.callParent('init', arguments);
		},

		embed: function () {
			this
				.fragment
				.childNodes[0]
				.setAttribute('src', this._captchaSrc);

			this.callParent('embed', arguments);
		},

		captchaApiSuccessHandler: function (data) {
			this.captchaId = this.getOption('captchaAlias') + ':' + data.answer.response.sid;
			var secure = this.getOption('secure'), address;
			if (secure) {
				address = '/sapi/' + secure[0] + '/' + secure[1] + '/captcha.show';
			} else {
				address = '/api/captcha.show';
			}

			this._captchaSrc = address + '?params={"id":"' + this.captchaId + '"}&rand=' + Math.random();
			this.render();
		},

		loadCaptcha: function () {
			this
				.rwom1('#captchaApi')
				.send({alias: this.getOption('captchaAlias')}, false);
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/captcha.js
// module id = 142
// module chunks = 5